var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "admin-base-layout",
    [
      _c("template", { slot: "admin-page-header" }, [
        _c("div", { staticClass: "flex-wrap-spacing" }, [
          _c("h3", { staticClass: "page-header" }, [
            _vm._v("Health & Monitoring")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-wrap-spacing health-actions" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary tests_add_namespace_action",
              on: {
                click: function($event) {
                  return _vm.getStats()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-sync-alt fa-fw" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "admin-page-content" },
        [
          !_vm.stats ? _c("loader") : _vm._e(),
          _vm._v(" "),
          _vm.stats
            ? _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 pad0" }, [
                    _c("div", { staticClass: "table-responsive" }, [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-hover tests_users_table table-50-50"
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Metric")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Value")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [_vm._v("DB latency")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.stats.db_lat) + " milliseconds"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("In Memory Cache latency")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.stats.memcache_lat) +
                                    " milliseconds"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("Internet Access")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.stats.internet_access))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("Processing elapsed")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.stats.lambda_elapsed) +
                                    " milliseconds"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("Total HTTP elapsed")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.stats.http_elapsed) +
                                    " milliseconds"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("Inferred HTTP latency")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.stats.http_elapsed -
                                      _vm.stats.lambda_elapsed
                                  ) + " milliseconds"
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 pad0" }, [
                    _c("div", { staticClass: "table-responsive" }, [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-hover table_envs tests_users_table table-50-50"
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Env Name")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Value")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.stats.process_env, function(v, k) {
                              return _c("tr", { key: k }, [
                                _c("td", { staticClass: "env_key_cell" }, [
                                  _vm._v(_vm._s(k))
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(v))])
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3637be52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3637be52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superadmin/Health.vue
// module id = null
// module chunks = 